<template>
  <div
    class="div-container-cluster"
  >
    <div
    
      style="background-color: white; min-height: 100vh;"
    >
      <b-row style="padding-bottom:10px">
        <b-col md="6">
       
          <h3>Selected clusters</h3>
        </b-col>
      
      </b-row>
      <b-row>
        <b-col>
          <b-table
            id="versionsTable"
            :fields="fields"
            :items="data"
            responsive
            striped
            class="mb-0"
            hover
            :busy="false"
            select-mode="single"
          >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
             
            </div>
          </template>

            
         
         
          >
          </b-table>
        </b-col> </b-row>
    </div>
   

  
    
      
  
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
import LiquorTree from 'liquor-tree'
import {
  BFormGroup, BButton, BTable, BCol, BRow
} from 'bootstrap-vue'

export default {
  components: {
    Multiselect,
    BFormGroup,
    BButton,
    vSelect,
    LiquorTree,
    BTable,
    BCol,
    BRow
  },
  props: {
    data: {
      required: false,
      type: Number,
      default: 0,
    },
   
  },
  data() {
    return {
      fields: [
        { key: 'cell_id', label: 'Cell', sortable: true },
        { key: 'version_name', label: 'Version', sortable: true },
        { key: 'version_id', label: 'Version id', sortable: true },
        { key: 'node_name', label: 'Node', sortable: true },
      
       
    
      ],
      test: ['prueba'],
      cluster: '',
      name: '',
      error: false,
      newNames: [],
      treeOptions: 
      {
  "selected": true,
  "selectable": true,
  "checked": true,
  "expanded": true,
  "disabled": false,
  "visible": true,
  "indeterminate": false,
  "matched": false,
  "editable": true,
  "dragging": false,
  "draggable": true,
  "dropable": true,
  "checkbox":true,
  "checkOnSelect":true
},
      
      treeData : [
  { text: 'Parent node test',state: { checkbox:true, checkOnSelect:true }, children: [
    {text: 'Version 72', children: [
      { text: 'Cell B', state: { selectable: true }},
      { text: 'Blanc', state: { selectable: true } }
    ]}]},

  { text: 'Children 1 test', children: [
    { text: 'Version 80', state: { selectable: true }, children: [
      { text: 'Cell B', state: { selectable: true } }

    ] },
    
  ]}
  // and so on ...
]
    }
  },
  computed: {
   
  },
  methods: {
    
    addAnnotation() {
      if (this.cluster !== '') {
        this.add({ name: this.name, cluster: this.cluster })
      } else {
        this.error = true
      }
    },
    addName(newName) {
      // if (this.alphanumeric(newName)) {
      this.newNames.push({ name: newName })
      this.name = { name: newName }
      /* } else {
        this.error = true
      } */
    },
    alphanumeric(inputtxt) {
      const letterNumber = /^[0-9a-zA-Z ]+$/
      if (inputtxt.value.match(letterNumber)) {
        return true
      }
      return false
    },
  },
}
</script>
<style>
.tree-checkbox{
  width: 15px !important;
  height: 15px !important;

}
.div-container-cluster{
  max-height: 500px;
}


</style>

